import * as Utils from "../utils";

export const schema = [
  {
    id: "/Types/Param/Type/Icon",
    type: "object",
    properties: {
      ...Utils.properties,
      default: {
        label: "Default value",
        type: "string",
        minLength: 1,
        default: "home",
        widget: "icon",
      },
    },
    required: ["default"],
  },
];
